import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getValue, appendPath, parentPath } from '@truqc/content-path';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';
import { equals } from 'ramda';
import moment from 'moment';
import DateTimePicker from '../../common/controls/dateTimePicker';
import { enabledSelector, labelSelector, valueSelector } from '../selectors/index';
import entityComposition from '../../common/classes/entityComposition';
import Label from './label';
import { getContent } from '../selectors/simpleSelectors';
// import logValueOnChange from '../selectors/logValueOnChange';

const createDays = endingDate => {
  const momentEndingDate = moment(endingDate);
  const days = {};
  for (let i = 6; i >= 0; i -= 1) {
    const date = momentEndingDate.clone().subtract(i, 'days');
    const key = moment.utc(date).toISOString();
    days[key] = {
      title: moment.utc(date).format('MM/DD/YYYY'),
      _created: key
    };
  }
  return days;
};
const removeDays = function removeDays() {
  let oldDays = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const result = {};
  // Clear all the old days
  Object.keys(oldDays).forEach(key => {
    result[key] = null;
  });
  return result;
};
const WeekEndingField = _ref => {
  let _ref$setCurrentDateOn = _ref.setCurrentDateOnUpdateToContentPath,
    setCurrentDateOnUpdateToContentPath = _ref$setCurrentDateOn === void 0 ? null : _ref$setCurrentDateOn,
    _ref$testingIdentifie = _ref.testingIdentifier,
    testingIdentifier = _ref$testingIdentifie === void 0 ? 'default-id' : _ref$testingIdentifie,
    _ref$daysContentPath = _ref.daysContentPath,
    daysContentPath = _ref$daysContentPath === void 0 ? null : _ref$daysContentPath,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? null : _ref$label,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? null : _ref$value,
    contentPath = _ref.contentPath,
    onChange = _ref.onChange,
    content = _ref.content,
    enabled = _ref.enabled,
    path = _ref.path;
  let valueInContent = value;
  if (setCurrentDateOnUpdateToContentPath) {
    valueInContent = getValue(setCurrentDateOnUpdateToContentPath, content);
  }
  const handleChange = date => {
    const endOfDay = moment.utc(date).endOf('day').milliseconds(0);
    const fullPath = contentPath.startsWith('/') ? contentPath : appendPath(parentPath(path), contentPath);
    const newValue = endOfDay.toISOString();
    onChange({
      path: fullPath,
      value: newValue,
      displayValue: newValue
    });
    if (daysContentPath) {
      const fullDayPath = daysContentPath.startsWith('/') ? daysContentPath : appendPath(parentPath(path), daysContentPath);
      const oldDays = removeDays(getValue(fullDayPath, content));
      const newDays = createDays(endOfDay);
      const days = _objectSpread(_objectSpread({}, oldDays), newDays);
      onChange({
        path: fullDayPath,
        value: days
      });
    }
  };
  const _useState = useState(valueInContent),
    _useState2 = _slicedToArray(_useState, 2),
    lastContentValue = _useState2[0],
    setLastContentValue = _useState2[1];
  if (!equals(lastContentValue, valueInContent) && valueInContent) {
    setLastContentValue(valueInContent);
    if (!value) {
      handleChange(moment.utc().endOf('isoWeek').toISOString());
    }
  }
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Label, {
    value: label
  }), enabled ? /*#__PURE__*/React.createElement(DateTimePicker, {
    onChange: handleChange,
    defaultValue: value,
    className: kebabCase(testingIdentifier),
    isValidDate: current => current.day() === 0
  }) : /*#__PURE__*/React.createElement("div", {
    className: kebabCase(testingIdentifier)
  }, moment(value).format('MM/DD/YYYY')));
};
WeekEndingField.propTypes = {
  content: PropTypes.shape({}).isRequired,
  contentPath: PropTypes.string.isRequired,
  daysContentPath: PropTypes.string,
  enabled: PropTypes.bool.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired,
  setCurrentDateOnUpdateToContentPath: PropTypes.string,
  testingIdentifier: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({}), PropTypes.array])
};
export { WeekEndingField as UncomposedWeekEndingField };
export default entityComposition(WeekEndingField, [], {
  enabled: enabledSelector,
  label: labelSelector,
  value: valueSelector,
  // onChange: logValueOnChange,
  content: getContent
});